// extracted by mini-css-extract-plugin
module.exports = {"subrow":"feed-log-details_subrow_27p2Q"};